export default __webpack_public_path__ + "static/media/april-2019-school-day.ea6b4d4d.csv";